export default "__VITE_ASSET__BP1996gh__"